import { FaLinkedinIn } from 'react-icons/fa6'
import { SiX, SiInstagram, SiGithub } from 'react-icons/si'
import { Globe } from 'lucide-react'
import ProfileHeader from '@/components/ProfileHeader'
import type { OwnerProfile, SocialLink } from '@/types'

interface Props {
  owner: OwnerProfile
}

const SOCIAL_ICONS: Record<SocialLink['platform'], React.ReactNode> = {
  linkedin: <FaLinkedinIn className="w-4 h-4" />,
  twitter: <SiX className="w-4 h-4" />,
  instagram: <SiInstagram className="w-4 h-4" />,
  github: <SiGithub className="w-4 h-4" />,
  website: <Globe className="w-4 h-4" />,
}

function SocialIcon({ link }: { link: SocialLink }) {
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="social-pill"
    >
      {SOCIAL_ICONS[link.platform]}
    </a>
  )
}

export default function ProfileCard({ owner }: Props) {
  const { firstName, lastName, picture, headline, socialLinks } = owner
  const hasSocials = (socialLinks?.length ?? 0) > 0

  return (
    <div className="card flex flex-col items-center gap-6">
      <ProfileHeader
        firstName={firstName}
        lastName={lastName}
        picture={picture}
        headline={headline}
      />

      {hasSocials && (
        <div className="profile-card-socials">
          {socialLinks!.map((link) => (
            <SocialIcon key={link.platform} link={link} />
          ))}
        </div>
      )}
    </div>
  )
}
